export const REPORT_BUT_EXTERNAL_LINK = 'https://support.twdc.technology/product/videosearch';
